/* drowsie-nav.js — the shared nav-bar behaviour for the layout:none landing pages.
   MN 2026-09-22, modelled on getbia.com/how-it-works:
     • an "Order Now" pill in the top right, immediately left of the sandwich
     • the bar slides away as you scroll down and comes straight back as you scroll up
   Every page that carries <header class="hdr"> gets it from this one file, so the pill and the
   behaviour stay identical across them. Injects its own CSS, so a page needs only the script tag. */
(function () {
  'use strict';

  // MN 09-23: the A$199 plan picker, not the A$249 speaker-only listing the pages never mention
  var HREF = '/pages/product#plan';
  var LABEL = 'Order Now';
  // a page whose own buy section is the right destination overrides it:
  //   <header class="hdr" data-cta-href="#plan">
  function href(hdr) { return hdr.getAttribute('data-cta-href') || HREF; }
  var SHOW_ABOVE = 90;     // never hidden this close to the top of the page
  var DEADZONE = 5;        // ignore scroll jitter smaller than this

  function styles() {
    if (document.getElementById('dzNavCss')) return;
    var st = document.createElement('style');
    st.id = 'dzNavCss';
    st.textContent = [
      // the Ozlo bar: a flat translucent ground with the page blurred behind it, not a fade-out
      '.hdr{background:rgba(11,10,20,.55);backdrop-filter:blur(20px) saturate(1.1);',
      '  -webkit-backdrop-filter:blur(16px) saturate(1.1);border-bottom:1px solid rgba(243,235,229,.1);',
      '  transition:transform .3s cubic-bezier(.22,.61,.36,1);will-change:transform}',
      'body.is-light .hdr{background:rgba(243,235,229,.62);border-bottom-color:rgba(28,28,31,.1)}',
      '.hdr.dz-away{transform:translateY(-101%)}',
      '.hdr .burger{margin-left:8px;flex:none}',
      '.hdr_cta{margin-left:auto;display:inline-flex;align-items:center;white-space:nowrap;flex:none;',
      // 09-25 MN: "feels a bit obnoxious" -> smaller and quieter. (The old `font:600 11px/1 inherit` shorthand was invalid,
      // so the pill silently inherited the body size in capitals.) Now: normal case, 13px, a slim outline pill.
      '  font-weight:600;font-size:13px;line-height:1;letter-spacing:.01em;text-transform:none;',
      '  text-decoration:none;color:#F3EBE5;background:rgba(255,255,255,.04);border:1px solid rgba(212,165,116,.55);border-radius:999px;padding:8px 14px;',
      '  transition:transform .16s cubic-bezier(.23,1,.32,1),opacity .2s ease}',
      '.hdr_cta:active{transform:scale(.97)}',
      '@media(hover:hover) and (pointer:fine){.hdr_cta:hover{background:linear-gradient(90deg,#C4787A,#D4A574);color:#1A1040;border-color:transparent}}',
      '.hdr_cta:focus-visible{outline:2px solid #F3EBE5;outline-offset:3px}',
      'body.is-light .hdr_cta{background:transparent;color:#1C1C1F;border-color:rgba(28,28,31,.3)}',
      // the sandwich menu looks the same on every page (09-23 audit found three pill styles and three grounds)
      '.menu{background:rgba(11,10,20,.96)!important}',
      '.menu a.pill{background:linear-gradient(90deg,#C4787A,#D4A574)!important;color:#1A1040!important;border:0!important;transition:transform .16s cubic-bezier(.23,1,.32,1)}',
      '.menu a.pill:active{transform:scale(.97)}',
      '@media(max-width:430px){.hdr_cta{font-size:12.5px;padding:7px 12px}}',
      '@media(prefers-reduced-motion:reduce){.hdr{transition:none}}'
    ].join('\n');
    document.head.appendChild(st);
  }

  function button(hdr) {
    if (hdr.querySelector('.hdr_cta')) return;
    var a = document.createElement('a');
    a.className = 'hdr_cta';
    a.href = href(hdr);
    a.textContent = LABEL;
    var burger = hdr.querySelector('.burger');
    if (burger) burger.parentNode.insertBefore(a, burger);
    else hdr.appendChild(a);
  }

  function slide(hdr) {
    var last = window.scrollY || 0, queued = false;
    function frame() {
      queued = false;
      var y = window.scrollY || 0; if (y < 0) y = 0;
      var dy = y - last;
      if (Math.abs(dy) < DEADZONE) return;            // `last` is left alone, so small moves still add up
      // the menu covers the screen: the bar carries its close button, so it never hides under it
      if (document.body.classList.contains('menu-open')) { last = y; hdr.classList.remove('dz-away'); return; }
      if (y <= SHOW_ABOVE) hdr.classList.remove('dz-away');
      else if (dy > 0) hdr.classList.add('dz-away');
      else hdr.classList.remove('dz-away');
      last = y;
    }
    addEventListener('scroll', function () {
      if (!queued) { queued = true; requestAnimationFrame(frame); }
    }, { passive: true });
  }

  function init() {
    var hdr = document.querySelector('header.hdr');
    if (!hdr) return;
    styles();
    button(hdr);
    slide(hdr);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
